interface Props {
    type: string;
    isPremium: any;
    [key: string]: any;
}
export const accountUserTypeMap = {
    trade: "Trade User",
    customer: "Customer",
    supplier: "Supplier",
    admin: "Admin",
    courier: "Courier",
    tradepremium: "Premium Trade User",
};
export const getUserType = (data: Props) => {
    if (data.type in accountUserTypeMap) {
        if (data.type === "trade" && data.isPremium) {
            return accountUserTypeMap["tradepremium"];
        }
        return accountUserTypeMap[data.type];
    }
    return "Guest";
};
